export default __webpack_public_path__ + "static/media/undraw_Wall_post_re_y78d.7e89630f.svg";